import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Collagen from "Images/shop/plp/collagen.png";
import Creatine from "Images/shop/plp/creatine.png";
import Fiber from "Images/shop/plp/fiber.png";
import Hydration from "Images/shop/plp/hsnc001.png";
import Protein from "Images/shop/plp/plpprotein.png";
import PreWorkout from "Images/shop/plp/pwt02.png";
import WaterBottle from "Images/checkout/waterbottle.png";
import BlenderBottle from "Images/checkout/blenderbottle.png";
import Greens1 from "Images/shop/greens_lemonginger_28.png";
import styles from "./styles.module.scss";
const accessories = [
    {
        title: "Watter Bottle",
        item_id: "wb221",
        img: WaterBottle,
        description: "22 oz. | Delivered Once",
        price: "$29.00",
        eyebrow: "ACCESSORY",
        cta: {
            copy: "Add To Cart",
        },
        href: "",
        reviews: null,
    },
    {
        title: "Blender Bottle",
        item_id: "blenderbottle",
        img: BlenderBottle,
        description: "19 oz. | Delivered Once",
        price: "$9.99",
        eyebrow: "ACCESSORY",
        cta: {
            copy: "Add To Cart",
        },
        href: "",
        reviews: null,
    },
];
const systemStarters = [
    {
        title: "Customized Protein Powder",
        item_id: "protein",
        img: Protein,
        description: "Customize to your dietary preference and goals",
        price: "$45.00",
        href: "/app/products/protein/",
        eyebrow: "CUSTOMIZED",
        cta: {
            copy: "Shop Now",
            href: "/app/products/protein/",
        },
        flavors: [
            {
                name: "Madagascar Vanilla",
                color: "#DDC9A3",
                href_flavor: "/app/products/protein/?FLAVORS=vanilla",
            },
            {
                name: "Rich Chocolate",
                color: "#795035",
                href_flavor: "/app/products/protein/?FLAVORS=chocolate",
            },
            {
                name: "Strawberry Cream",
                color: "#DBA5AB",
                href_flavor: "/app/products/protein/?FLAVORS=strawberry",
            },
        ],
        additional_flavor_count: 6,
        reviews: (_jsx("div", { className: ["yotpo bottomLine review-stars", styles.yotpo].join(" "), "data-product-id": "protein", "data-price": "2200", "data-currency": "USD", "data-name": "Personalized Pre-Workout", "data-url": "https://www.gainful.com/product/preworkout", "data-image-url": "https://google.com/", style: {
                marginTop: 5,
                display: "flex",
            } })),
    },
    {
        title: "Performance Greens",
        item_id: "greens",
        img: Greens1,
        eyebrow: "",
        price: "$42.00",
        description: "Delicious and powerful individually-packed servings for optimal daily nutrition",
        href: "/app/products/greens/",
        cta: {
            copy: "Shop Now",
            href: "/app/products/greens/",
        },
        flavors: [
            {
                name: "Lemon Ginger",
                color: "#FEDB00",
                href_flavor: "/app/products/greens/?FLAVOR=lemonginger",
            },
            {
                name: "Tropical Pineapple",
                color: "#E0EC89",
                href_flavor: "/app/products/greens/?FLAVOR=tropicalpineapple",
            },
        ],
        reviews: (_jsx("div", { className: ["yotpo bottomLine review-stars", styles.yotpo].join(" "), "data-product-id": "greens", "data-price": "4200", "data-currency": "USD", "data-name": "Performance Greens", "data-url": "https://www.gainful.com/product/greens", "data-image-url": "https://google.com/", style: {
                marginTop: 5,
                display: "flex",
            } })),
    },
    {
        title: "Customized Hydration",
        item_id: "hydration",
        img: Hydration,
        description: "Customize to your caffeine preference and sweat levels",
        price: "$30.00",
        href: "/app/products/hydration/",
        eyebrow: "CUSTOMIZED",
        cta: {
            copy: "Shop Now",
            href: "/app/products/hydration/",
        },
        flavors: [
            {
                name: "Strawberry Lemonade",
                color: "#F48782",
                href_flavor: "/app/products/hydration/?FLAVOR=SL",
            },
            {
                name: "Tropical Mango",
                color: "#F3AF21",
                href_flavor: "/app/products/hydration/?FLAVOR=MANGO",
            },
            {
                name: "Lemon Lime",
                color: "#DFE88B",
                href_flavor: "/app/products/hydration/?FLAVOR=LL",
            },
        ],
        reviews: (_jsx("div", { className: ["yotpo bottomLine review-stars", styles.yotpo].join(" "), "data-product-id": "high_caff_strawberrylemonade", "data-price": "3000", "data-currency": "USD", "data-name": "Personalized Hydration", "data-url": "https://www.gainful.com/product/hydration", "data-image-url": "https://google.com/", style: {
                marginTop: 5,
                display: "flex",
            } })),
    },
    {
        title: "Customized Pre-Workout",
        item_id: "preworkout",
        img: PreWorkout,
        description: "Customize to your caffeine preference and exercise intensity",
        price: "$26.00",
        href: "/app/products/preworkout/",
        eyebrow: "CUSTOMIZED",
        cta: {
            copy: "Shop Now",
            href: "/app/products/preworkout/",
        },
        flavors: [
            {
                name: "Watermelon",
                color: "#7DC46E",
                href_flavor: "/app/products/preworkout/?FLAVOR=WATERMELON",
            },
            {
                name: "Strawberry Lemonade",
                color: "#F48782",
                href_flavor: "/app/products/preworkout/?FLAVOR=SL",
            },
        ],
        reviews: (_jsx("div", { className: ["yotpo bottomLine review-stars", styles.yotpo].join(" "), "data-product-id": "preworkout", "data-price": "2200", "data-currency": "USD", "data-name": "Personalized Pre-Workout", "data-url": "https://www.gainful.com/product/preworkout", "data-image-url": "https://google.com/", style: {
                marginTop: 5,
                display: "flex",
            } })),
    },
];
const performanceBoosts = [
    {
        title: "Creatine Monohydrate",
        item_id: "creatine",
        img: Creatine,
        description: "Add for muscle growth and cognitive benefits",
        price: "$22.00",
        href: "/app/products/creatine/",
        eyebrow: "Performance boost",
        cta: {
            copy: "Shop Now",
            skuToAdd: "creatine",
        },
        reviews: (_jsx("div", { className: ["yotpo bottomLine review-stars", styles.yotpo].join(" "), "data-product-id": "creatine", "data-price": "1700", "data-currency": "USD", "data-name": "Creatine", "data-url": "https://www.gainful.com/product/boosts", "data-image-url": "https://google.com/", style: {
                marginTop: 5,
                display: "flex",
            } })),
    },
    {
        title: "Grass Fed Collagen",
        item_id: "collagen",
        img: Collagen,
        description: "Add for overall joint health and tissue health ",
        price: "$22.00",
        href: "/app/products/collagen/",
        eyebrow: "Performance boost",
        cta: {
            copy: "Shop Now",
            skuToAdd: "collagen",
        },
        reviews: (_jsx("div", { className: ["yotpo bottomLine review-stars", styles.yotpo].join(" "), "data-product-id": "collagen", "data-price": "1700", "data-currency": "USD", "data-name": "Collagen", "data-url": "https://www.gainful.com/product/boosts", "data-image-url": "https://google.com/", style: {
                marginTop: 5,
                display: "flex",
            } })),
    },
    {
        title: "Oat Bran Fiber",
        item_id: "fiber",
        img: Fiber,
        description: "Add for optimal gut health and for satiety",
        price: "$22.00",
        href: "/app/products/fiber/",
        eyebrow: "Performance boost",
        cta: {
            copy: "Shop Now",
            skuToAdd: "fiber",
        },
        reviews: (_jsx("div", { className: ["yotpo bottomLine review-stars", styles.yotpo].join(" "), "data-product-id": "fiber", "data-price": "1700", "data-currency": "USD", "data-name": "Fiber", "data-url": "https://www.gainful.com/product/boosts", "data-image-url": "https://google.com/", style: {
                marginTop: 5,
                display: "flex",
            } })),
    },
];
export default {
    systemStarters,
    performanceBoosts,
    accessories,
};
